import jwtDecode from 'jwt-decode';

/** UI preference only — session persistence is driven by the HttpOnly UserSessionId cookie. */
export const STAY_SIGNED_IN_KEY = 'staySignedIn';

export function isStaySignedInEnabled(): boolean {
  return localStorage.getItem(STAY_SIGNED_IN_KEY) === 'true';
}

export function setAuthSessionPreference(staySignedIn: boolean): void {
  localStorage.setItem(STAY_SIGNED_IN_KEY, String(staySignedIn));
}

export function clearAuthStorage(): void {
  localStorage.removeItem(STAY_SIGNED_IN_KEY);
  // legacy cleanup
  localStorage.removeItem('userSessionId');
}

export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<{ exp?: number }>(token);
    if (!decoded?.exp) {
      return true;
    }
    return decoded.exp < Date.now() / 1000;
  } catch {
    return true;
  }
}
